import React, { Fragment } from "react";
import cx from "classnames";

import { steps } from "../config";
import { ButtonIcon } from "./Button";

export default function ScreenHead({
  title,
  breadcrumbs,
  onBack,
  onClick,
  onClose,
  step,
}) {
  const onPressCrumb = (idx) => {
    if (idx < step) {
      onClick(steps[idx === 1 ? 0 : idx]);
    }
  };

  return (
    <Fragment>
      <div className="screen__head u-clearfix">
        {onBack !== false && (
          <ButtonIcon
            name="keyboard_arrow_left"
            className="screen__back"
            onClick={onBack}
          />
        )}
        {Boolean(onClose) && (
          <ButtonIcon
            name="close"
            className="screen__close"
            onClick={onClose}
          />
        )}
        <h3 className="screen__title">{title}</h3>
      </div>
      {breadcrumbs.length > 0 && (
        <div className="screen__steps">
          <ol className="steps">
            {breadcrumbs.map((crumb, idx) => {
              if (!crumb) {
                return null;
              }

              return (
                <li
                  key={crumb}
                  onClick={() => onPressCrumb(idx)}
                  className={cx("step", {
                    "step--current": idx === step,
                    "step--disabled": idx > step,
                    "step--enabled": idx < step,
                  })}
                >
                  <a>{crumb}</a>
                </li>
              );
            })}
          </ol>
        </div>
      )}
    </Fragment>
  );
}
